export const getItem = (key) => {
  const value = window.localStorage.getItem(key) || null;
  return value;
};
export const setItem = (key, value) => {
  window.localStorage.setItem(key, value);
};

export const removeItem = (key) => {
  window.localStorage.removeItem(key);
};

export const keys = {
  'MyTaskActionDate': 'event-planning-my-task-action-date',
  'MyLibrarySearchMainData': 'event-planning-my-library-search-main-data',
  'MyLibrarySearchDetailData': 'event-planning-my-library-search-detail-data',
  'MyTaskSearchMainData': 'event-planning-my-task-search-main-data',
  'MyTaskSearchDetailData': 'event-planning-my-task-search-detail-data',
  'MyAuthorizedTaskSearchMainData': 'event-planning-my-authorized-task-search-main-data',
  'MyAuthorizedTaskSearchDetailData': 'event-planning-my-authorized-task-search-detail-data',
  'MyApplicationSearchMainData': 'event-planning-my-application-search-main-data',
  'MyApplicationSearchDetailData': 'event-planning-my-application-search-detail-data',
  'UserSelectedRoleInMyTask': 'event-planning-user-selected-role-in-my-task',
}



// WEBPACK FOOTER //
// ./src/util/StorageService.js